<template>
  <div class="stats-card" :class="cardClass" role="region" :aria-labelledby="headingId">
    <h2 :id="headingId">{{ title }}</h2>
    <div class="count" aria-live="polite">{{ count }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'StatsCard',
  props: {
    title: {
      type: String,
      required: true
    },
    count: {
      type: Number,
      default: 0
    },
    cardClass: {
      type: String,
      default: ''
    },
    headingId: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.stats-card {
  /* Apex主题卡片背景 */
  background: rgba(13, 26, 45, 0.85); /* 深蓝半透明 */
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(102, 126, 234, 0.3); /* Apex蓝色边框 */
}

.stats-card h2 {
  color: #ffcc00; /* Apex金色文字 */
  margin-bottom: 15px;
  font-size: 1.5rem;
  text-align: center;
  text-shadow: 0 0 5px rgba(255, 204, 0, 0.3);
}

.count {
  font-size: 3rem;
  font-weight: bold;
  /* Apex蓝色数字 */
  color: #667eea;
  text-align: center;
  margin: 15px 0;
  text-shadow: 0 0 10px rgba(102, 126, 234, 0.5);
}

/* 移动端适配 */
@media (max-width: 768px) {
  .stats-card {
    padding: 20px 15px;
    margin-bottom: 20px;
  }
  
  .stats-card h2 {
    font-size: 1.3rem;
    margin-bottom: 10px;
  }
  
  .count {
    font-size: 2.5rem;
    margin: 10px 0;
  }
}

/* 小屏幕适配 */
@media (max-width: 480px) {
  .stats-card {
    padding: 15px 10px;
  }
  
  .stats-card h2 {
    font-size: 1.2rem;
  }
  
  .count {
    font-size: 2rem;
  }
}
</style>